// NPM Imports
import React from "react";

// Component Imports
import DocumentSettings from "./DocumentSettings";
import DocumentSettingsUpgrade from "./DocumentSettingsUpgrade";
import { FeatureGating } from "../../commonComponents";

// Internal Imports
import { FEATURES } from "../../constants";

// Destructuring
const { FEATURES_NAME } = FEATURES;

export default function (props) {
  return (
    <FeatureGating
      name={FEATURES_NAME.DOCUMENT_FORWARDING}
      altComponent={
        <DocumentSettingsUpgrade
          {...props}
          featureName={FEATURES_NAME.DOCUMENT_FORWARDING}
        />
      }>
      <DocumentSettings {...props} />
    </FeatureGating>
  );
}
